import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import * as React from "react";
import Search from "./Search";

const Header = ({ rightElement }) => {
  return (
    <div
      className={`navbar my-3 bg-base-100 flex ${
        rightElement === "searchBox" ? "flex-row" : "flex-col sm:flex-row"
      }`}
    >
      <Link to="/" className="flex-1">
        <div className="avatar w-16 mr-3">
          <StaticImage
            src="../images/book.png"
            alt="Founder's Bookshelf"
            width={72}
            loading="eager"
            formats={["auto", "webp", "avif"]}
          />
        </div>
        <div
          className={rightElement === "searchBox" ? "hidden sm:flex" : "flex"}
        >
          <h2 className="text-3xl font-bold">Founder's Bookshelf</h2>
        </div>
      </Link>

      <div className="flex-none">
        {rightElement === "searchBox" ? (
          <Search />
        ) : (
          <a
            role="button"
            href="https://twitter.com/_smanna"
            target={"_blank"}
            rel="noreferrer"
            className="btn btn-outline lowercase"
          >
            <div className="avatar w-8 mr-2">
              <div className="relative rounded-full">
                <StaticImage
                  src="../images/twitter.jpg"
                  alt="Suvojit Manna"
                  loading="eager"
                  width={64}
                  formats={["auto", "webp"]}
                />
              </div>
            </div>
            <span>by @_smanna</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default Header;
